import React, { useState, useEffect } from "react";
import {
  Button,
  ButtonGroup,
  Card,
  CardBody,
  CardTitle,
  CardText,
  Row,
  Col,
  InputGroup,
  Input,
  Modal,
  ModalBody,
  Label,
  ModalHeader,
  ModalFooter,
} from "reactstrap";
import { Link } from "react-router-dom";
import { Triangle } from "react-loader-spinner";
import PaymenttypeService from "../../services/PackageType Service/PackagetypeService";
import useIsSmallScreen from "./Component/small screen/SmallScreen";
import CustomDataTable from "../../Components/CustomTable/CustomTable";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import EditModal from "./Component/EditModal";
import PaymentTypeServices from "../../services/OrderingServices/PaymentTypeService";
import DeleteModal from "../../Components/Common/DeleteModal";
import toast from "react-hot-toast";

const PaymentType = () => {
  const [loading, setLoading] = useState(false);
  const [paymentTypeList, setPaymentTypeList] = useState([]);
  const [modal, setModal] = useState(false);
  const [editingPackage, setEditingPackage] = useState(null);
  console.log("🚀 ~ PaymentType ~ editingPackage:", editingPackage);
  const [newPackage, setNewPackage] = useState({
    title: "",
    gst_percent: "",
    service_fee_percent: "",
  });
  const [deleteModal, setDeleteModal] = useState(false);
  const [isDetailOpen, setIsDetailOpen] = useState(false);
  const toggleDetail = (item) => {
    setEditingPackage(item);
    setIsDetailOpen(!isDetailOpen);
  };
  const isSmallScreen = useIsSmallScreen();

  const toggleModal = () => {
    setModal((prev) => !prev);
    if (modal) {
      // When closing the modal, reset newPackage and editingPackage
      setNewPackage({
        title: "",
        description: "",
      });
      setEditingPackage(null);
    }
  };

  const handleEdit = (row) => {
    setEditingPackage(row);
    setNewPackage({
      title: row.title,
      description: row.description,
    });
    setModal(true); // Open modal directly
  };

  const handleCreate = () => {
    // Explicitly reset for creating a new payment type
    setEditingPackage(null);
    setNewPackage({
      title: "",
      description: "",
    });
    setModal(true); // Open modal for creating
  };

  const fetchPaymentType = async () => {
    setLoading(true);
    try {
      const response = await PaymentTypeServices.getList();
      setPaymentTypeList(response);
    } catch (error) {
      console.error("Error fetching payment types:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPaymentType();
  }, []);

  const savePackage = (updatedPackage) => {
    setPaymentTypeList((prevList) =>
      prevList.map((pkg) =>
        pkg.id === editingPackage.id ? { ...pkg, ...updatedPackage } : pkg
      )
    );
  };

  const columns = [
    {
      name: "S.N",
      selector: (row, index) => index + 1,
      sortable: true,
    },
    {
      name: "Name",
      selector: (row) => row?.name,
      sortable: true,
    },
    {
      name: "Description",
      selector: (row) => `${row?.description || ""}`,
      sortable: true,
    },
    {
      name: "Actions",
      cell: (row) => (
        <ButtonGroup className="">
          <Button
            color="btn btn-soft-success"
            className="btn-sm"
            onClick={() => toggleDetail(row)}
          >
            <i className="bx bx-show" />
          </Button>

          <Button
            color="btn btn-soft-warning"
            className="btn-sm ms-1"
            onClick={() => handleEdit(row)}
          >
            <i className="ri-edit-line" />
          </Button>
          <Button
            className="btn btn-soft-danger btn-sm ms-1"
            color="danger"
            onClick={() => handleDeleteClick(row.id)}
          >
            <i className="ri-delete-bin-5-line" />
          </Button>
        </ButtonGroup>
      ),
      center: true,
    },
  ];

  const [filterText, setFilterText] = useState("");

  const handleFilterChange = (e) => {
    setFilterText(e.target.value);
  };

  const toggleDeleteModal = () => setDeleteModal(!deleteModal);
  const handleDeleteClick = (item) => {
    setEditingPackage(item);
    toggleDeleteModal();
  };
  const handleDelete = async () => {
    if (editingPackage) {
      try {
        await PaymentTypeServices.delete(editingPackage);
        setPaymentTypeList((prevList) =>
          prevList.filter((pkg) => pkg.id !== editingPackage)
        );
        toast.success("Selected payment type deleted successfully");
      } catch (error) {
        toast.error("Failed to delete the record");
      } finally {
        toggleDeleteModal();
        setEditingPackage(null);
      }
    }
  };

  const filteredData = paymentTypeList.filter((item) =>
    item?.name?.toLowerCase().includes(filterText.toLowerCase())
  );

  return (
    <div className="page-content">
      <div className="container-fluid">
        <BreadCrumb title="Payment Type" pageTitle="Payment Type" />
      </div>
      <Row>
        <Col md={8} xs={12} className="mb-2">
          <InputGroup>
            <Input
              placeholder="Search by name "
              value={filterText}
              onChange={handleFilterChange}
            />
          </InputGroup>
        </Col>
        <Col
          md={4}
          xs={12}
          className="d-flex justify-content-end align-items-end mb-2"
        >
          <button
            className="btn btn-success px-1 px-sm-2"
            onClick={handleCreate} // Use handleCreate instead of toggleModal
          >
            + Add payment type
          </button>
        </Col>
      </Row>
      {isSmallScreen ? (
        loading ? (
          <div className="d-flex justify-content-center my-3">
            <Triangle
              visible={true}
              height="80"
              width="80"
              color="#5B71B9"
              ariaLabel="triangle-loading"
            />
          </div>
        ) : (
          <Row>
            {paymentTypeList.map((item, index) => (
              <Col md={12} key={index} className="mb-1 smallScreen">
                <Card>
                  <CardBody>
                    <CardTitle tag="h5">{item.title}</CardTitle>
                    <CardText>
                      <strong>GST:</strong> {item.gst_percent}%
                    </CardText>
                    <CardText>
                      <strong>Service Fee:</strong> {item.service_fee_percent}%
                    </CardText>
                    <CardText>
                      <strong>Service Fee Amount:</strong>{" "}
                      {item.service_fee_amount}
                    </CardText>
                    <div className="text-end">
                      <Button
                        color="warning"
                        className="rounded-circle btn-sm"
                        onClick={() => handleEdit(item)}
                      >
                        <i className="bx bx-edit"></i>
                      </Button>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            ))}
          </Row>
        )
      ) : (
        <CustomDataTable
          responsive
          striped
          pagination
          fixedHeader
          persistTableHead
          progressPending={loading}
          columns={columns}
          data={filteredData}
          customStyles={{
            headCells: {
              style: {
                fontSize: "0.93rem",
                fontWeight: 610,
              },
            },
            rows: {
              style: {
                fontSize: "0.9rem",
              },
            },
          }}
          progressComponent={
            <div className="my-3">
              <Triangle
                visible={true}
                height="80"
                width="80"
                color="#5B71B9"
                ariaLabel="triangle-loading"
              />
              <h5 className="mt-1">Loading...</h5>
            </div>
          }
        />
      )}

      <EditModal
        modal={modal}
        toggleModal={toggleModal}
        editingPackage={editingPackage}
        savePackage={savePackage}
        newPackage={newPackage}
        setNewPackage={setNewPackage}
        fetchPaymentType={fetchPaymentType}
      />
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDelete}
        onCloseClick={toggleDeleteModal}
        selectedItem={editingPackage}
      />

      <Modal isOpen={isDetailOpen} toggle={toggleDetail}>
        <ModalHeader toggle={toggleDetail}>Payment Type Detail</ModalHeader>
        <ModalBody>
          <Label>Name</Label>
          <h6>{editingPackage?.name}</h6>
          <Label>Description</Label>
          <p>{editingPackage?.description}</p>
        </ModalBody>
      </Modal>
    </div>
  );
};

export default PaymentType;
